module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.htmlString.length) ? _c('div', {
    staticClass: "app-html-render",
    class: _vm.modClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.htmlString)
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62cc5fbe","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/htmlrender/HtmlRender/AppHtmlRender.vue
// module id = eb27ffb4903038adfec7
// module chunks = 89